import React from "react";
import { isNull } from "lodash";
import PropTypes from "prop-types";
import classNames from "classnames";
import ValidationError from "@client.components/ValidationError";
import "./Input.scss";

export const Input = ({
  value = "",
  type = "text",
  className,
  inputClassName,
  onChange,
  placeholder,
  error = null,
  disabled,
  optional,
  preLabel,
  suffix,
}) => {
  return (
    <div className={classNames("input-container", inputClassName)}>
      <div
        className={classNames("input-holder", {
          "is-invalid": !isNull(error),
          disabled: disabled,
        })}
      >
        {preLabel && <div className="pre-label">{preLabel}</div>}
        <input
          type={type}
          className={classNames("input", className)}
          value={value}
          placeholder={placeholder}
          disabled={disabled}
          onChange={(event) => {
            onChange(event.target.value);
          }}
          {...optional}
        />
        {suffix && <div className="suffix">{suffix}</div>}
      </div>
      <ValidationError error={error} />
    </div>
  );
};

Input.propTypes = {
  preLabel: PropTypes.string,
  value: PropTypes.any,
  type: PropTypes.string,
  disabled: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  className: PropTypes.string,
  inputClassName: PropTypes.string,
  placeholder: PropTypes.string,
  error: PropTypes.array,
  optional: PropTypes.object,
  suffix: PropTypes.string,
};
